import { Component, OnInit } from '@angular/core';
import { ButtonComponent } from '@components/button/button.component';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Registry } from '@/registry.service';
import { faPenToSquare } from '@fortawesome/free-solid-svg-icons';
import { CommissionsSignalmanModel } from '@/models/tables/commissions-signalman.model';
import { DialogCommissionSignalmanComponent } from '@pages/tables/commission-signalman/dialog-commission/dialog-commission-signalman.component';

@Component({
  selector: 'app-button-detail-commission-signalman',
  templateUrl: '../../button.component.html',
  styleUrls: ['../../button.component.scss'],
})
export class ButtonDetailCommissionSignalmanComponent extends ButtonComponent implements OnInit {
  faIcon = faPenToSquare;
  private dialogOpened: MatDialogRef<any>;
  private commissionsSignalmanModel: CommissionsSignalmanModel;
  private rowData: any;

  constructor(
    protected router: Router,
    protected toastr: ToastrService,
    private dialog: MatDialog,
  ) {
    super(router, toastr);

    this.showIcon = true;
    this.additionalClass = 'py-0.5 px-2.5';
    this.toolTip = 'Dettaglio provvigione';
    this.smallBtn = true;
  }

  ngOnInit() {
    this.commissionsSignalmanModel = <CommissionsSignalmanModel>this.rowData;
  }

  /**
   * Open modal new detail page
   */
  public actionClick(): void {
    this.dialogOpened = this.dialog.open(DialogCommissionSignalmanComponent, {
      data: this.commissionsSignalmanModel,
    });

    Registry.getInstance().set('ButtonDetailCommissionSignalmanComponent', this.dialogOpened);
  }
}
